import { Button, Typography, TypographyProps } from "@mui/material";
import { sxButton } from "../sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { ReactElement, ReactNode } from "react";



export default function TypographyAccessibility({ children, style, ...props }: TypographyProps)  {

    const { textStyleAccessibility } = useAccessibility();


    return (<Typography {...props} style={{ ...textStyleAccessibility, ...style }}>{children}</Typography>)
}
